import { HTTP } from "./common";

export const AlertApi = {

  list() {
    return HTTP.get(`alerts/`).then((response) => {
      return response.data;
    });
  },
  set_read(obj) {
    return HTTP.put(`alerts/${obj.id}/set_read/`, obj).then((response) => {
      return response.data;
    });
  },
  set_all_read() {
    return HTTP.post(`alerts/set_all_read/`).then((response) => {
      return response.data;
    });
  },


};


